/**
 * BAMBOOVE — PARALLAX NHE CHO HERO  (12/10/2026 · phieu 54)
 * ---------------------------------------------------------------------------
 * Y tuong hoc tu `parallax-hero` cua Shrine/Impulse — TU VIET, khong chep ma.
 *
 * NGUYEN TAC AN TOAN:
 *   - CHI chay tren man hinh >= 990px (dien thoai KHONG parallax: ton pin, giat).
 *   - Ton trong "giam chuyen dong" => khong lam gi.
 *   - Nhe: dich chuyen toi da ~60px, nhan them `scale(1.08)` de KHONG lo vien trang.
 *   - Dung requestAnimationFrame (1 lan/khung hinh), khong nghe scroll truc tiep.
 *   - Khong tim thay `.bb-hero__media` => thoat im lang.
 */
(function () {
  'use strict';

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!window.matchMedia) return;

  var MQ_DESKTOP = window.matchMedia('(min-width: 990px)');
  var HE_SO = 0.12; // nhe nhu y chot: 5-12%
  var TOI_DA = 60; // px

  var dangCho = false;

  function capNhat() {
    dangCho = false;

    if (!MQ_DESKTOP.matches) {
      var tatCa = document.querySelectorAll('[data-bb-parallax-media]');
      for (var t = 0; t < tatCa.length; t++) {
        tatCa[t].style.transform = '';
        tatCa[t].removeAttribute('data-bb-parallax-media');
      }
      return;
    }

    var heros = document.querySelectorAll('.bb-hero');
    for (var i = 0; i < heros.length; i++) {
      var media = heros[i].querySelector('.bb-hero__media');
      if (!media) continue;

      var hop = heros[i].getBoundingClientRect();
      if (hop.bottom < 0 || hop.top > window.innerHeight) continue; // ngoai khung nhin

      // Khach da cuon qua bao xa trong long hero (0 => vua cham dinh)
      // PHIEN 65 (13/10/2026) — SUA LOI "anh hero giat / phong to ngay khi moi load":
      //   luc moi load hero nam DUOI dinh trang => `hop.top` > 0 => `daCuon` AM
      //   => file ap ngay `translateY(-11px) scale(1.08)` khong transition
      //   => anh NHay 1 cu + PHONG TO 8% (do: media 1440x807 -> 1555x872).
      //   => (1) chua cuon thi KHONG transform gi  (2) phong LON DAN theo muc cuon.
      var daCuon = Math.max(0, -hop.top);
      var lech = Math.max(-TOI_DA, Math.min(TOI_DA, daCuon * HE_SO));

      if (daCuon <= 0) {
        media.style.transform = '';
        media.removeAttribute('data-bb-parallax-media');
        continue;
      }

      // He so phong: 1,00 khi vua cham dinh -> 1,08 khi cuon qua 240px
      var heSoPhong = 1 + 0.08 * Math.min(1, daCuon / 240);

      media.setAttribute('data-bb-parallax-media', '1');
      media.style.transform = 'translate3d(0,' + lech.toFixed(2) + 'px,0) scale(' + heSoPhong.toFixed(4) + ')';
    }
  }

  function hen() {
    if (dangCho) return;
    dangCho = true;
    window.requestAnimationFrame(capNhat);
  }

  // Dat `will-change` 1 lan cho lop media (chi khi co hero)
  function chuanBi() {
    var ds = document.querySelectorAll('.bb-hero__media');
    for (var i = 0; i < ds.length; i++) {
      ds[i].style.willChange = 'transform';
    }
    capNhat();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      chuanBi();
      window.addEventListener('scroll', hen, { passive: true });
      window.addEventListener('resize', hen, { passive: true });
    });
  } else {
    chuanBi();
    window.addEventListener('scroll', hen, { passive: true });
    window.addEventListener('resize', hen, { passive: true });
  }

  document.addEventListener('shopify:section:load', hen);
})();
